import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { createConversation, getMessageTypes } from '../../actions/admin/header/messageActions';
import { getAllUsersByCLients } from "../../actions/admin/userManagementActions";
import { clearFileUploads } from "../../actions/fileUploadActions";
import { Typeahead } from "react-bootstrap-typeahead";
import { Button } from '../../components/buttons';
import Spinner from 'react-bootstrap/Spinner';
import { useAuth } from "../../context/authContext";
import { FileUpload } from '../../components/FileUpload';

const componentName = "ComposeMessage";

const ComposeMessage = ({ closeModal }) => {
    let auth = useAuth();
    const token = auth.getAuthToken();
    const [emailData, setEmailData] = useState({});
    const [msgType, setMsgType] = useState({});
    const handleChangeWithinModal = (e, error) => {
        const { name, value } = e.target;
        setEmailData({
            ...emailData,
            [name]: value,
        });
        isFormValid();
    };
    const handleUploadFileChange = (arr) => {
        setUploadedFiles(arr);
    };

    const { allUsers } = useSelector((state) => state.userManagement);
    const { fileObject } = useSelector((state) => state.fileUpload);
    const { messageTypes } = useSelector((state) => state.messages);
    const dispatch = useDispatch();
    const [users, setUsers] = useState([]);
    const [, setFileAdded] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [urgent, setUrgent] = useState(false);

    const handleChange = (e) => {
        if (e.length === 0) {
            setMsgType([]);
        } else {
            setMsgType(e[0]);
        }
        isFormValid();
    };

    const createConvAndSend = async () => {
        let userId = auth.getUserId();
        const converseMessage = {
            conversationDto: {
                title: emailData.title,
                participants: [...users, userId],
                messageType: msgType,
            },
            messageDto: {
                title: emailData.title,
                message: emailData.message,
                messageType: msgType,
                important: urgent,
            },
        };
        if (uploadedFiles && uploadedFiles.length) {
            converseMessage.messageDto["uploadedFiles"] = uploadedFiles;
        }
        await dispatch(createConversation(converseMessage));
        onModalClose();
    };

    const updateUsers = async (e, error) => {
        let idArray = [];
        e.forEach((user) => {
            idArray.push(user.id);
            setUsers(idArray);
        });
        if (e.length === 0) {
            setUsers([]);
        }
    };

    useEffect(() => {
        (async function fetchData() {
            if (!messageTypes.length) {
                await dispatch(getMessageTypes(token));
            }
        })();
    }, []);

    const isFormValid = () => {
        const { title, message } = emailData;
        if (
            title &&
            msgType &&
            message &&
            users &&
            title.length &&
            msgType.length &&
            message.length &&
            users.length
        ) {
            return false;
        } else {
            return true;
        }
    };

    const onModalClose = async () => {
        await dispatch(clearFileUploads());

        await closeModal();
    }

    useEffect(() => {
        (async function fetchMessages() {
            if (!allUsers.length) {
                await dispatch(getAllUsersByCLients());
            }
        })();
    }, []);

    useEffect(() => {
        if (fileObject) {
            setFileAdded(fileObject);
        }
    }, [fileObject]);

    return (
        <>
            {allUsers && allUsers.length ? (
                <>
                    <div className="modal-body">
                        <form>
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group m-b-10">
                                        <label id={`${componentName}-chooseUsersLabel`} className="d-block">Choose Users<span className="text-danger">*</span></label>
                                        <Typeahead
                                            id={`${componentName}-chooseUsersValue`}
                                            inputProps={{
                                                id: `${componentName}-chooseUsersValue`
                                            }}
                                            multiple
                                            labelKey="email"
                                            onChange={(e) => updateUsers(e)}
                                            options={allUsers}
                                        />
                                    </div>
                                    <div className="form-group m-b-10">
                                        <b className="d-block">Choose Message Type<span className="text-danger">*</span></b>
                                        <Typeahead
                                            id={`${componentName}-chooseMessageTypesValue`}
                                            inputProps={{
                                                id: `${componentName}-chooseMessageTypesValue`
                                            }}
                                            labelKey="msgType"
                                            onChange={(e) => handleChange(e)}
                                            options={messageTypes}
                                        />
                                    </div>
                                    <div className="form-group m-b-10">
                                        <b className="d-block">Subject<span className="text-danger">*</span></b>
                                        <input
                                            type="text"
                                            onChange={(e) => handleChangeWithinModal(e)}
                                            className="form-control"
                                            name="title"
                                        />
                                    </div>
                                    <div className="form-group m-b-10">
                                        <FileUpload
                                            onChange={handleUploadFileChange}
                                            clearStateProp={0}
                                        />
                                    </div>
                                    <div className="form-group m-b-0">
                                        <b className="d-block">Message<span className="text-danger">*</span></b>
                                        <textarea
                                            className="form-control"
                                            name="message"
                                            onChange={(e) => handleChangeWithinModal(e)}
                                            rows="5"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <div className="me-auto">
                            <label className="custom-control custom-checkbox">
                                <input
                                    value={urgent}
                                    type="checkbox"
                                    name="markUrgent"
                                    onClick={() => setUrgent(!urgent)}
                                    className="custom-control-input"
                                />
                                <span className="custom-control-label">Mark As Urgent</span>
                            </label>
                        </div>
                        <Button className="btn" data-dismiss="modal" onClick={() => onModalClose()}>
                            Cancel
                        </Button>
                        <Button
                            className="btn btn-primary"
                            onClick={() => createConvAndSend()}
                            disabled={isFormValid()}>
                            Send
                        </Button>
                    </div>
                </>
            ) : (
                <>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />{" "}
                    Loading...
                </>
            )}
        </>
    );
}

export default ComposeMessage;